module.exports = [
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duschsystem mit Einhandmischer<br />für die Wandmontage",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Das GROHE Euphoria Cube XXL Duschsystem mit Einhandarmatur, Chromoberfläche, deutsche Technik, mit 230 mm-Kopfbrause und Einfachstrahl-Handbrause.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Kopfbrauseset Deckenauslass 154 mm ",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset 380 mm",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310, Kopfbrauseset, 142-mm-Deckenauslass, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180, Kopfbrauseset zur Wandmontage mit 286 mm langem Brausearm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Das GROHE Euphoria XXL Duschsystem mit Thermostat, Chromoberfläche, deutsche Technik, mit 310 mm-Kopfbrause und 110 mm Dreifachstrahl-Handbrause.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower 310 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 Duschsystem  mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "GROHE SilverFlex Schlauch mit Drehverbinder für TwistFree Funktion, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "GROHE SilverFlex Schlauch mit Drehverbinder für TwistFree Funktion, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Seitenbrause 1 Strahlart",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27265000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27265000/640/27265000.jpg",
		"headline": "Euphoria 110 Mono",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27265000",
		"textblock_2nd_text": "GROHE Euphoria 110 Mono, Handbrause, 1 Strahlbild",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27265000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie und Seitenbrausen für die Wandmontage",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat und Seitenbrausen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brausearm 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368000/640/28368000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrause 1 Strahlart",
		"textblock_1st_text": "28368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Brauseschlauch",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "GROHE SilverFlex Schlauch mit Drehverbinder für TwistFree Funktion, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Wannenfüll-, <br />Ab- und Überlaufgarnitur",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28628000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28628000/640/28628000.jpg",
		"headline": "Relexa",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "28628000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28628000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Brausestangenset 1 Strahlart",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Duschsystem Unterputz mit Rainshower® Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Grohtherm Cube Perfect Brausegarnitur mit Rainshower Allure Kopfbrause mit 230 mm Durchmesser, Euphoria Cube Handbrause und Rapido T Thermostat-Armatur für die Unterputzmontage.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostat-Brauseset 1/2\"",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M Brausethermostat mit GROHE Euphoria 110 Massage Brausegarnitur, 600-mm-Brausestange",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostat-Brauseset 1/2\"",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M Brausethermostat mit GROHE Euphoria 110 Massage Brausegarnitur, 900-mm-Brausestange",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35500000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35500000/640/35500000.jpg",
		"headline": "GROHE Rapido T",
		"subheadline": "Unterputz-Thermostatbatterie",
		"textblock_1st_text": "35500000",
		"textblock_2nd_text": "GROHE Rapido T Unterputz-Thermostatbatterie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/35500000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G223",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27661000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27661000/640/27661000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Handbrause 2 Strahlarten",
		"textblock_1st_text": "27661000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Handbrause, 115 mm, 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27661000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Handbrause 4+ Strahlarten",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 130, Handbrause, 4+ Strahlarten",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (160 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Brausestangenset 2 Strahlarten",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brausestange, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Brausestange, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset 422 mm",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wandhalterset 4+ Strahlarten",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandbrausehalter",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset 286 mm",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset 380 mm",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Wandhalterset 2 Strahlarten",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (115 mm), Brauseschlauch (1.250 mm) und Handbrausehalter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Wandhalterset 2 Strahlarten",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (115 mm), Brauseschlauch (1.250 mm) und Handbrausehalter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (600 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (160 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Brausestangenset 2 Strahlarten",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (115 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27765000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27765000/640/27765000.jpg",
		"headline": "Power&Soul Cosmopolitan 190",
		"subheadline": "Kopfbrause 4+ Strahlarten",
		"textblock_1st_text": "27765000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Kopfbrause, 190 mm, 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27765000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27911000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27911000/640/27911000.jpg",
		"headline": "Euphoria Power&Soul System 190",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27911000",
		"textblock_2nd_text": "GROHE Euphoria Power&Soul 190 Duschsystem mit Umstellung; Chromoberfläche, hergestellt in Deutschland, mit 190 mm großer Kopfbrause und Handbrause mit 2 Strahloptionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27911000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "<strong>Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage</strong>",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat und Wanneneinlauf",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandbrausehalter",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 Duschsystem mit Umstellung",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27134000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27134000/640/27134000.jpg",
		"headline": "Rainshower Cosmopolitan 160",
		"subheadline": "Kopfbrause 4 Strahlarten",
		"textblock_1st_text": "27134000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27134000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G165",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 Duschsystem mit Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handbrause 1 Strahlart",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Brausestangenset 1 Strahlart",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan Set mit Handbrause (130 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (900 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Brausestangenset 4+ Strahlarten",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "GROHE Power&Soul Set mit Handbrause (130 mm), Brausestange (600 mm) und Brauseschlauch (1.750 mm), 9,5l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19355001",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19355001/640/19355001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19355001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/19355001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19567000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19567000/640/19567000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19567000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Armatur mit 2-Wege-Umstellung (Wanne oder Dusche mit mehr als 1 Brause) für GROHE Rapido T Unterputz-Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/19567000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19468000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19468000/640/19468000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Thermostat mit integrierter 2-Wege-Umstellung<br />für Wanne oder Dusche mit mehr als einer Brause",
		"textblock_1st_text": "19468000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Armatur mit 2-Wege-Umstellung (Wanne oder Dusche mit mehr als 1 Brause) für GROHE Rapido T Unterputz-Thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/19468000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Wannenfüll-, <br />Ab- und Überlaufgarnitur",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Wannenauslauf",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Wannenauslauf",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "Eurocube",
		"subheadline": "Wannenauslauf",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Duschsystem Unterputz mit Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Grohtherm 3000 Cosmopolitan Perfect Brausegarnitur mit Rainshower Cosmopolitan Kopfbrause aus Metall und 310 mm Durchmesser, Sena Handbrause und Rapido T Thermostat-Armatur für die Unterputzmontage.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO Aufputz-Duschsystem mit Thermostat. Chromoberfläche umweltfreundlich und in Deutschland hergestellt. 360-mm-Kopfbrause und 115-mm-Handbrause mit vier Strahlarten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Aufputz-Duschsystem mit Thermostat Chromoberfläche, umweltfreundlich und in Deutschland gefertigt, 360-mm-Kopfbrause mit GROHE TrioMassage Strahl und 115-mm-Handbrause mit zwei Strahlarten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Kopfbrauseset 422 mm",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Kopfbrauseset 450 mm, 2 Strahlarten",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "GROHE Rainshower 360 DUO Kopfbrauseset. Chromoberfläche, hergestellt in Deutschland: 360-mm-Kopfbrause mit GROHE TrioMassage Strahl und 450-mm-Brausearm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Eurocube Wandanschlussbogen, mit Chromoberfläche, deutsche Technik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "<strong>Thermostat-Brausebatterie 1/2\" mit Brausegarnitur</strong>",
		"textblock_1st_text": "34195001",
		"textblock_2nd_text": "Grohtherm 2000 Duschthermostat mit GROHE Euphoria Brausestangenset (bestehend aus 110-mm-Handbrause mit drei Strahloptionen, 600-mm-Stange und 1750-mm-Schlauch)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27696000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27696000/640/27696000.jpg",
		"headline": "Euphoria Cube System 150",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27696000",
		"textblock_2nd_text": "GROHE Euphoria Cube 152 Duschsystem mit Umstellung; Chromoberfläche, deutsche Technik, mit 152-mm-Kopfbrause und Stick-Handbrause",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27696000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Duschsystem Unterputz mit Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Grohtherm 3000 Cosmopolitan Perfect Brausegarnitur mit Rainshower Cosmopolitan Kopfbrause aus Metall und 310 mm Durchmesser, Sena Handbrause und Rapido T Thermostat-Armatur für die Unterputzmontage.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Duschsystem Unterputz mit Rainshower® Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Grohtherm 2000 Perfect Brausegarnitur mit Rainshower Cosmopolitan Kopfbrause aus Metall und 210 mm Durchmesser, Euphoria Cosmopolitan Handbrause und Rapido T Thermostat-Armatur für die Unterputzmontage.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28679000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28679000/640/28679000.jpg",
		"headline": "Relexa",
		"subheadline": "Wandanschlussbogen, 1/2\"",
		"textblock_1st_text": "28679000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/28679000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "Rapido SmartBox",
		"subheadline": "Universal Unterputz-Einbaukörper, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Sicherungseinrichtung (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "GROHE Euphoria 260 Duschsystem mit Thermostat, 260 mm großer Kopfbrause mit drei Strahlarten und 110 mm großer Handbrause mit drei Strahlarten mit Chromoberfläche. Einfach zu installieren und zu reinigen. Deutsche Technik",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "<strong>Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage</strong>",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 Bad-/Duschsystem mit Thermostat für Badewannen, wassersparender, 260 mm großer Kopfbrause SmartControl mit drei Strahlarten und 110 mm großer Handbrause mit drei Strahlarten mit Chromoberfläche. Deutsche Technik",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Einhandmischer<br />für die Wandmontage",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "GROHE Euphoria 260 Duschsystem mit Einhand-Armatur, wassersparender, 260 mm großer Kopfbrause SmartControl mit 3 Strahlarten, 110 mm großer Handbrause mit 3 Strahlarten und Chromoberfläche. Deutsche Technik",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23061002",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23061002/640/23061002.jpg",
		"headline": "Euphoria Concetto System 260",
		"subheadline": "Duschsystem mit Einhandmischer<br />für die Wandmontage",
		"textblock_1st_text": "23061002",
		"textblock_2nd_text": "GROHE Euphoria Concetto 260 Duschsystem mit Einhandarmatur, wassersparender 260 mm großer Kopfbrause SmartControl mit 3 Strahlarten und Stick Handbrause und Chromoberfläche. Deutsche Technik",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/23061002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Duschsystem mit Thermostat und 210 mm großer Kopfbrause und 100 mm großer Handbrause mit zwei Strahlarten und Chromoberfläche. Einfach zu installieren und zu reinigen. Deutsche Technik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duschsystem mit Einhandmischer<br />für die Wandmontage",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Duschsystem mit Einhandarmatur und 210 mm großer Kopfbrause und 100 mm großer Handbrause mit zwei Strahlarten und Chromoberfläche. Einfach zu installieren und zu reinigen. Deutsche Technik",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "<strong>Duschsystem mit Thermostat-Wannenbatterie für die Wandmontage</strong>",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Duschsystem mit Thermostat für Badewannen und 210 mm großer Kopfbrause und 100 mm großer Handbrause mit zwei Strahlarten und Chromoberfläche. Einfach zu installieren und zu reinigen. Deutsche Technik",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal Unterputz-Einbaukörper, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "<strong>Thermostat-Brausebatterie 1/2\" mit Brausegarnitur</strong>",
		"textblock_1st_text": "34566001",
		"textblock_2nd_text": "Grohtherm 800 Duschthermostat mit GROHE New Tempesta Brausestangenset (bestehend aus 100-mm-Handbrause mit zwei Strahloptionen, 900-mm-Stange und 1750-mm-Schlauch)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "GROHE Euphoria 260 Duschsystem mit Umstellung. Wassersparende 260 mm große Kopfbrause SmartControl mit drei Strahlarten und 110 mm große Handbrause mit drei Strahlarten mit Chromoberfläche. Hergestellt in Deutschland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Flex Duschsystem mit Umstellung für die Wandmontage",
		"textblock_1st_text": "26381001",
		"textblock_2nd_text": "GROHE New Tempesta 210 FLEX Duschsystem mit Umstellung; kompatibel mit allen vorhandenen Ventilen für einfache Veränderungen. Hergestellt in Deutschland mit einer 210 m langen Kopfbrause mit zwei Strahloptionen und einer 100 mm großen Handbrause.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 3 Strahlarten",
		"textblock_1st_text": "26460000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl Kopfbrauseset mit drei Strahlzonen. 260-mm-Brause und GROHE Rainshower Deckenauslass (142 mm) mit Chromoberfläche. Einfach zu installieren und zu reinigen. Hergestellt in Deutschland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Duschsystem Unterputz mit Tempesta 210",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "Grohtherm 1000 Perfect Brausegarnitur mit 210 mm großer Kopfbrause und 100 mm großer Handbrause mit zwei Strahlarten und Chromoberfläche.  Deutsche Technik",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "GROHE Euphoria 260 Duschsystem mit Thermostat, wassersparendem SmartControl, 260 mm-großer Kopfbrause mit 3 Strahlarten und 110 mm-großer Handbrause mit 3 Strahlarten mit Chromoberfläche. Einfach zu installieren und zu reinigen. Deutsche Technik",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE Kopfbrauseset mit 2 Strahloptionen. 310-mm-Brause für die Deckenmontage, mit 142-mm-Brausearm, Chromoberfläche und weißem Brauseboden, quadratische Form. Hergestellt in Deutschland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE Kopfbrauseset mit 2 Strahloptionen. 310 mm deckenmontierte Spülbrause mit 142 mm Brausearm, Chromoberfläche, eckige Form. Hergestellt in Deutschland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Kopfbrauseset 430 mm, 2 Strahlarten",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE Kopfbrauseset mit 2 Strahloptionen. 310-mm-Brause für die Wandmontage und 400-mm-Brausearm, Chromoberfläche und weißer Brauseboden, quadratische Form. Hergestellt in Deutschland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive Kopfbrauseset mit 2 Strahloptionen. 310 mm deckenmontierte Spülbrause mit 142 mm Brausearm, Chromoberfläche und weißem Brauseboden, runde Form. Hergestellt in Deutschland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "<strong>Thermostat-Brausebatterie 1/2\" mit Brausegarnitur</strong>",
		"textblock_1st_text": "34565001",
		"textblock_2nd_text": "Grohtherm 800 Duschthermostat mit GROHE New Tempesta Brausestangenset (bestehend aus 100-mm-Handbrause mit zwei Strahloptionen, 600-mm-Stange und 1750-mm-Schlauch)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "<strong>Thermostat-Brausebatterie 1/2\" mit Brausegarnitur</strong>",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "<strong>Thermostat-Brausebatterie 1/2\" mit Brausegarnitur</strong>",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Kopfbrauseset Deckenauslass 142 mm, 2 Strahlarten",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive Kopfbrauseset mit 2 Strahloptionen. 310 mm deckenmontierte Spülbrause mit 142 mm Brausearm, Chromoberfläche, runde Form. Hergestellt in Deutschland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Kopfbrauseset 430 mm, 2 Strahlarten",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive Kopfbrauseset mit 2 Strahloptionen. 310 mm wandmontierte Spülbrause mit 400 mm Brausearm, Chromoberfläche und weißem Brauseboden, runde Form. Hergestellt in Deutschland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Duschsystem Unterputz mit Rainshower SmartActive 310 Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Grohtherm SmartControl Perfect Brausegarnitur mit Thermostat für Unterputzmontage mit drei Ventilen, Kopfbrause, Handbrause, Duscharm, Schlauch. Quadratische Form. Chromoberfläche, hergestellt in Deutschland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Duschsystem Unterputz mit Rainshower SmartActive 310",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Grohtherm SmartControl Perfect Brausegarnitur mit Thermostat für Unterputzmontage mit drei Ventilen, Kopfbrause, Handbrause, Duscharm, Schlauch. Runde Form. Chromoberfläche, hergestellt in Deutschland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Kopfbrauseset 380 mm, 3 Strahlarten",
		"textblock_1st_text": "26458000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl Kopfbrauseset mit drei Strahlzonen. 260-mm-Brause und GROHE Rainshower Duscharm (380 mm) mit Chromoberfläche. Einfach zu installieren und zu reinigen. Hergestellt in Deutschland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für die Dusche, für die Unterputzmontage und mit einem Ventil. Eckige Form, Chromoberfläche, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für Dusche oder Badewanne, für die Unterputzmontage, mit 3 Ventilen. Eckige Form, Chromoberfläche, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen und integriertem Brausehalter",
		"textblock_1st_text": "29125000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für die Dusche oder Badewanne, für die Unterputzmontage, mit zwei Ventilen. Eckige Form, Chromoberfläche, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für die Dusche, für die Unterputzmontage und mit einem Ventil. Eckige Form, Moon White, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für die Dusche oder Badewanne, für die Unterputzmontage, mit zwei Ventilen. Eckige Form, Moon White, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für Dusche oder Badewanne, für die Unterputzmontage, mit 3 Ventilen. Eckige Form, Moon White, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für die Dusche, für die Unterputzmontage und mit einem Ventil. Runde Form, Chromoberfläche, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für die Dusche oder Badewanne, für die Unterputzmontage, mit zwei Ventilen. Runde Form, Chromoberfläche, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 1 Absperrventil",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für die Dusche, für die Unterputzmontage und mit einem Ventil. Runde Form, Moon White, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für die Dusche oder Badewanne, für die Unterputzmontage, mit zwei Ventilen. Runde Form, Moon White, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für Dusche oder Badewanne, für die Unterputzmontage, mit 3 Ventilen. Runde Form, Moon White, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatbatterie mit 3 Absperrventilen<br /> Auf-/Unterputz Kombination",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "Grohtherm SmartControl Kombi-Duschthermostat mit drei Ventilen. Chromoberfläche mit weißer Ablage, deutsche Technik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatbatterie mit 2 Absperrventilen<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "34714000",
		"textblock_2nd_text": "Grohtherm SmartControl Kombi-Duschthermostat mit zwei Ventilen. Chromoberfläche mit weißer Ablage, deutsche Technik.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Unterputz-Einbaukörper für Thermostat Auf-/Unterputz Kombination",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26405000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26405000/640/26405000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Wandhalterset 1 Strahlart",
		"textblock_1st_text": "26405000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26405000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 2 Absperrventilen und integriertem Brausehalter",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für die Dusche oder Badewanne, für die Unterputzmontage, mit zwei Ventilen und integriertem Anschlussstück. Runde Form, Chromoberfläche, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostat mit 3 Absperrventilen",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Grohtherm SmartControl Thermostat für Dusche oder Badewanne, für die Unterputzmontage, mit 3 Ventilen. Runde Form, Chromoberfläche, hergestellt in Deutschland von GROHE. Umweltfreundlich und mit Sicherheitsfunktionen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO Aufputz-Duschsystem mit Thermostat. Chromoberfläche umweltfreundlich und in Deutschland hergestellt. 360-mm-Kopfbrause (weißer Brauseboden) und 115-mm-Handbrause mit vier Strahloptionen.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Duschsystem mit Thermostatbatterie,<br />Auf-/Unterputz Kombination",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi Duschsystem mit Thermostat. Chromoberfläche umweltfreundlich und in Deutschland hergestellt. 360-mm-Kopfbrause mit GROHE TrioMassage Strahl und 115-mm-Handbrause mit zwei Strahloptionen.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Duschsystem mit Thermostatbatterie für die Wandmontage",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Aufputz-Duschsystem mit Thermostat Chromoberfläche, umweltfreundlich und in Deutschland gefertigt, 360-mm-Kopfbrause (weißer Brauseboden) mit GROHE TrioMassage Strahl und 115-mm-Handbrause mit zwei Strahloptionen.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Kopfbrauseset 450 mm, 2 Strahlarten",
		"textblock_1st_text": "26254LS0",
		"textblock_2nd_text": "GROHE Rainshower 360 DUO Kopfbrauseset, Chromoberfläche, hergestellt in Deutschland: 360-mm-Kopfbrause (weißer Brauseboden) mit GROHE TrioMassage Strahl und 450-mm-Kopfbrausearm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rohbauset für Kopfbrause-Set",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Handbrause 4+ Strahlarten",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Handbrause 2 Strahlarten",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.at/de_at/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.at/de_at/service/ausstellungen-fachinstallateure.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_products_de_at.json
// module id = 823
// module chunks = 0